import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_setprojection(x: number) {
  LwAPI?.setProjection(x);
}

document
  .getElementById("orthogonalProjection")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_setprojection(0);
  });

document.getElementById("parallelProjection")?.addEventListener("click", async () => {
  await apiReady;
  ex_setprojection(1);
});
